// extracted by mini-css-extract-plugin
export default {"politic":"PersonalData_politic__gmRqb","container":"PersonalData_container__Rj8KV","title":"PersonalData_title__ITfad","politic__title":"PersonalData_politic__title__1SO7Y"};